import React from 'react';

export default function Title() {
  return <span className="outfit-selector__title">Outfit</span>;
}
